import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { materialSymbols } from '../../../shared/constants/material-symbols';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
    standalone: false
})
export class PaginationComponent implements OnChanges {
  @Input() id: string = 'paginator'
  @Input() totalRecords: number = 0;
  @Input() recordsPerPage: number = 10;
  @Input() currentPage: number = 1;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
  description: string = '';
  pageNumbers: string[] = [];

  keyboardDoubleRight = materialSymbols.keyboardDoubleArrowRight;
  keyboardDoubleLeft = materialSymbols.keyboardDoubleArrowLeft;
  arrowForwardIos = materialSymbols.arrowForwardIos;
  arrowBackIos = materialSymbols.arrowBackIos;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalRecords'] || changes['recordsPerPage'] || changes['currentPage']) {
      if (this.currentPage < 1) {
        this.currentPage = 1;
      }
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }

      this.pageNumbers = this.getPageNumbers(this.currentPage, this.totalPages);
    }
  }

  get totalPages(): number {
    return Math.ceil(this.totalRecords / this.recordsPerPage);
  }

  onPageNumClicked(buttonValue: string) : void {
    let parsedVal = parseInt(buttonValue);
    if(isNaN(parsedVal)) {
      return;
    }

    this.onPageChange(parsedVal);
  } 

  onPageChange(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  getPageNumbers(currentPage: number, totalPages: number) : string[] {
    let pageNumbers : string[] = [];
    if(totalPages <= 7) {
      for(let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i.toString());
      }
    } else {

      // Insert Page 1
      pageNumbers.push('1');

      if(currentPage >= 5) {
        pageNumbers.push('...')
      }

      // Add page numbers between first and last page
      if(currentPage <= 3) {
        pageNumbers.push('2');
        pageNumbers.push('3');
        pageNumbers.push('4');
        pageNumbers.push('5');

      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push((totalPages - 4).toString());
        pageNumbers.push((totalPages - 3).toString());
        pageNumbers.push((totalPages - 2).toString());
        pageNumbers.push((totalPages - 1).toString());

      } else {
        for(let i = currentPage - 2; i <= currentPage + 2; i++) {
          pageNumbers.push(i.toString());
        }

      }

      if(currentPage <= totalPages - 4) {
        pageNumbers.push('...')
      }

      // Insert Last Page
      pageNumbers.push(totalPages.toString());

    }

    return pageNumbers;
  }
}
